import { Component } from '@angular/core';

@Component({
    selector: 'copy-right',
    imports: [],
    templateUrl: './copy-right.component.html',
    styleUrl: './copy-right.component.scss'
})
export class CopyRightComponent {}
